import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  output,
} from '@angular/core';

import { DictionaryDetailsForm } from '../../../shared/models/dictionary-details-form';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { DictionaryDetailsFormComponent } from '../../../shared/containers/dictionary-details-form/dictionary-details-form.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpErrorService } from '@web/common';
import { HttpErrorResponse } from '@angular/common/http';
import { AdminDictionaryProductAttributeDataSourceService } from '../../services/admin-dictionary-product-attribute-data-source.service';

@Component({
  selector: 'app-dictionary-product-attribute-create',
  imports: [DictionaryDetailsFormComponent, AlertsComponent],
  templateUrl: './admin-dictionary-product-attribute-create.component.html',
  styleUrl: './admin-dictionary-product-attribute-create.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminDictionaryProductAttributeCreateComponent {
  /* prettier-ignore */
  private readonly adminDictionaryDataSource = inject(AdminDictionaryProductAttributeDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly submitSuccessEvent = output();

  private readonly destroyRef = inject(DestroyRef);

  public handleSubmitClickEvent(data: DictionaryDetailsForm): void {
    this.adminDictionaryDataSource
      .createByFormData(data)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.submitSuccessEvent.emit(),
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
